import script from "./siloSetupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./siloSetupModal.vue?vue&type=script&setup=true&lang=js"

import "./siloSetupModal.vue?vue&type=style&index=0&id=b18d2a42&lang=css"

const __exports__ = script;

export default __exports__